import { HeaderItem } from '@owc-packages/Header/src/Header';
import { HeaderTopAllowedComponents, HeaderTopItems } from '@owc-packages/Header/src/Header.enums';

export const PERMITTED_LANGUAGES: string[] = ['en', 'de', 'pt'];
export const DEFAULT_LANGUAGE = 'en';
export const HEADER_OPEN_MENU_EVENT_NAME = 'open-menu-action';
export const HEADER_FLYOUT_OPEN_SCROLL_LOCK = 'scroll-lock';

export const HEADER_MAIN_NAV_FLYOUT = 'owc-header-nav-flyout';
export const HEADER_MAIN_NAV_LIST_CLASS = 'owc-header-flyout__navigation-list';
export const AEM_AUTHOR_CLASS = 'owc-header-author';
export const FOCUS_STACK_HEADER_CONTEXT = 'owc-header';

export const THROTTLE_TIMER = 100;

export const HEADER_JUMP_TO_CONTENT_ID = 'first-web-component';

export const HEADER_MOBILE_MENUS: HeaderItem[] = [
  {
    iconLabel: 'bds/menu/16',
    type: HeaderTopAllowedComponents.HEADER_BUTTON,
    id: HeaderTopItems.HEADER_MOBILE_MENU,
    class: 'owc-header__item-menu',
  },
  {
    iconLabel: 'bds/car/24', //TODO: Replace this as soon as we have icon bds/car/16 available on wb
    type: HeaderTopAllowedComponents.HEADER_BUTTON,
    id: HeaderTopItems.HEADER_MODELS_MENU,
    class: 'owc-header__item-menu',
  },
];
